export const mainContainerWidths = ['100%', '420px', '420px', '552px', '584px']
export const narrowContainerWidths = ['100%', '420px', '420px', '464px', '464px']
export const wideContainerWidths = ['87.5%', '420px', '720px', '944px', '992px']
